import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';
import { TRANSITION_CONFIRM_PAYMENT, TRANSITION_REQUEST_PAYOUT } from '../../util/transaction';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchOrganizationById } from '../../ducks/organizations.duck';

// Fetch transactions helper (moved from removed InboxPage)
const fetchTransactions = queryParams => (dispatch, getState, sdk) => {
  return sdk.transactions.query({
    ...queryParams,
    include: ['provider', 'provider.profileImage', 'customer', 'customer.profileImage', 'booking', 'listing'],
  });
};

// ================ Action types ================ //

export const FETCH_PAYMENTS_REQUEST = 'app/PaymentHistoryPage/FETCH_PAYMENTS_REQUEST';
export const FETCH_PAYMENTS_SUCCESS = 'app/PaymentHistoryPage/FETCH_PAYMENTS_SUCCESS';
export const FETCH_PAYMENTS_ERROR = 'app/PaymentHistoryPage/FETCH_PAYMENTS_ERROR';

export const FETCH_ALL_PAYMENTS_REQUEST = 'app/PaymentHistoryPage/FETCH_ALL_PAYMENTS_REQUEST';
export const FETCH_ALL_PAYMENTS_SUCCESS = 'app/PaymentHistoryPage/FETCH_ALL_PAYMENTS_SUCCESS';
export const FETCH_ALL_PAYMENTS_ERROR = 'app/PaymentHistoryPage/FETCH_ALL_PAYMENTS_ERROR';

// ================ Reducer ================ //

const entityRefs = entities =>
  entities.map(entity => ({
    id: entity.id,
    type: entity.type,
  }));

const initialState = {
  fetchInProgress: false,
  fetchPaymentsError: null,
  pagination: null,
  transactionRefs: [],
};

export default function paymentHistoryPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_PAYMENTS_REQUEST:
      return { ...state, fetchInProgress: true, fetchPaymentsError: null };
    case FETCH_PAYMENTS_SUCCESS: {
      const transactions = payload.data.data;
      return {
        ...state,
        fetchInProgress: false,
        transactionRefs: entityRefs(transactions),
        pagination: payload.data.meta,
      };
    }
    case FETCH_PAYMENTS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchInProgress: false, fetchPaymentsError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchPaymentsRequest = () => ({ type: FETCH_PAYMENTS_REQUEST });
const fetchPaymentsSuccess = response => ({
  type: FETCH_PAYMENTS_SUCCESS,
  payload: response,
});
const fetchPaymentsError = e => ({
  type: FETCH_PAYMENTS_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

const PAYMENTS_PAGE_SIZE = 10;

export const loadData = (params, search) => async (dispatch, getState, sdk) => {
  dispatch(fetchPaymentsRequest());

  const { page = 1 } = parse(search);

  try {
    const selectedOrganization = await dispatch(fetchOrganizationById(params.orgId));
    const selectedOrganizationId = selectedOrganization ? selectedOrganization.id : null;

    const queryParams = {
      only: 'sale',
      sort: 'lastTransitionedAt',
      lastTransitions: [TRANSITION_CONFIRM_PAYMENT, TRANSITION_REQUEST_PAYOUT],
      page,
      perPage: PAYMENTS_PAGE_SIZE,
      meta_organizationId: selectedOrganizationId,
    };

    const filteredTransactionsResponse = await dispatch(fetchTransactions(queryParams));

    dispatch(addMarketplaceEntities(filteredTransactionsResponse));
    dispatch(fetchPaymentsSuccess(filteredTransactionsResponse));

    return filteredTransactionsResponse;
  } catch (error) {
    dispatch(fetchPaymentsError(storableError(error)));
  }
};
